<template>
    <div class="ah-page income-statement-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>收支項目設定</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-button v-if="isSAAdmin" type="dark" @click="$router.push({ name: 'trade-statements-editor' })">收支範本編輯器</el-button>
            <el-button v-if="!isQR()" type="primary" style="margin-bottom: 20px" @click="onOpenDialog">
                匯入範本
            </el-button>
            <ah-tip style="margin-left: 10px">
                首次建立請點選範本，快速勾選您想用的收支項目，也可於下方自行新增或刪除項目。<br />
                （子項目需填寫才會出現於首頁）
            </ah-tip>
            <div class="ah-panel">
                <div class="panel-body">
                    <IncomeStatementEditor :key="statementEditorKey" />
                </div>
            </div>
        </div>
        <BulkSetupStatementDialog :visible="isDialogVisible" :key="`${statementEditorKey}-dialog`" @refresh="onRefreshDialog" @close="onCloseDialog" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BulkSetupStatementDialog from '@/components/ui/Statement/BulkSetupStatementDialog.vue';
import IncomeStatementEditor from './IncomeStatementEditor.vue';

export default {
    name: 'income-statement-editor',
    components: { IncomeStatementEditor, BulkSetupStatementDialog },
    created() {
        if (this.isAuth('G02')) this.$store.dispatch('accounting/updateAccountingSettings');
    },
    computed: {
        ...mapGetters({ isSAAdmin: 'account/isSAAdmin' }),
    },
    data() {
        return {
            isFirstTime: false,

            isDialogVisible: false,
            statementEditorKey: +new Date(),
        };
    },
    methods: {
        onOpenDialog() {
            this.isDialogVisible = true;
        },
        onCloseDialog() {
            this.isDialogVisible = false;
        },
        onRefreshDialog() {
            setTimeout(() => {
                this.statementEditorKey = +new Date();
            }, 300);
        },
    },
    beforeDestroy() {
        if (localStorage.getItem('token')) this.$store.dispatch('statement/updateStatementOptions');
    },
};
</script>
